import Table from './Table'
import TableLoader from './TableLoader'
export * from './interface'
export { Table, TableLoader }
export default Table
